/* import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { useObserverDimensionsElement } from '@/data/hooks/useObserverDimensionsElement';
import { combineSX } from '@/utils/combineSX';
import { Grid, SxProps } from '@mui/material';

interface DpProductGridCardProps {
	href?: string;
	image: string;
	imagemobile?: string;
	sx?: SxProps;
	alt?: string;
}

export const DpProductGridCard = ({
	href,
	image,
	imagemobile,
	sx,
	alt,
	...rest
}: DpProductGridCardProps) => {
	const frameRef = document.querySelector('.product-card-plp-content');
	const imageDimensions = useObserverDimensionsElement(frameRef);

	const isMobile = useIsMobile();

	const imageToUse = isMobile ? imagemobile || image : image;

	return (
		<Grid item xs={6} md={4} display="flex" {...rest}>
			<Linkable href={href}>
				<Img
					src={imageToUse}
					sx={combineSX([
						{
							objectFit: 'stretch',
							objectPosition: 'center',
							width: `${imageDimensions.width}px !important`,
							height: `${imageDimensions.width}px !important`,
							minWidth: `${imageDimensions.width}px !important`,
							minHeight: `${imageDimensions.height}px !important`,
							maxWidth: `${imageDimensions.width}px !important`,
							maxHeight: `${imageDimensions.height}px !important`,
						},
						Array.isArray(sx) ? sx : [sx],
					])}
					alt={alt}
				/>
			</Linkable>
		</Grid>
	);
};
*/
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { Grid } from '@mui/material';

export const DpProductGridCard = ({ href, image }: { href?: string; image: string }) => (
	<Grid item xs={6} md={4} display="flex">
		<Linkable href={href}>
			<Img
				src={image}
				sx={{
					objectFit: 'cover',
					width: { xs: '100%', md: '350px' },
					height: '100%',
				}}
			/>
		</Linkable>
	</Grid>
);
